/**
 * D11: per-user app-JWT (выдаётся бэкендом после Google OIDC). Хранится в localStorage,
 * шлётся в заголовке X-AlgoSys-Local-Token (тот же путь, что и статический local-ui токен —
 * бэкенд сначала сверяет с local_ui_bearer_token, иначе jwt.decode → user_id).
 */
const KEY = 'algosys_user_token';

export function getUserToken(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setUserToken(token: string): void {
  try {
    localStorage.setItem(KEY, token);
  } catch {
    /* ignore */
  }
}

export function clearUserToken(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

/** После OIDC-редиректа бэкенд возвращает токен во фрагменте (#access_token=...). Забираем и чистим URL. */
export function captureTokenFromUrl(): void {
  if (typeof window === 'undefined') return;
  const m = window.location.hash.match(/[#&]access_token=([^&]+)/);
  if (m && m[1]) {
    setUserToken(decodeURIComponent(m[1]));
    const clean = window.location.pathname + window.location.search;
    window.history.replaceState(null, '', clean || '/');
  }
}

export function startGoogleLogin(): void {
  window.location.href = '/api/auth/google/login';
}

export function logout(): void {
  clearUserToken();
  fetch('/api/auth/logout', { method: 'POST' }).catch(() => {});
  window.location.assign('/');
}
